import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import HelmetCustom from "../../components/HelmetCustom";
import { logoCabecalho } from "../../util/logoLoja";
import api from "../../services/api";
import Loading from "../../components/Loading";
import {
  Container,
  Content,
  Title,
  Subtitle,
  InfoBox,
  InfoLabel,
  InfoValue,
  Icon,
  Logo
} from "./styles";

export default function SiteEmConstrucao() {
  const identidade = useSelector(state => state.identidadeVisual?.data);
  const [empresa, setEmpresa] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function loadEmpresa() {
      try {
        const response = await api.get('/stores/domain');
        if (response.data && response.data.store && response.data.store.empresa) {
          setEmpresa(response.data.store.empresa);
        }
        setLoading(false);
      } catch (err) {
        console.error('Erro ao carregar dados da empresa:', err);
        setError(true);
        setLoading(false);
      }
    }

    loadEmpresa();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <HelmetCustom title="Site em Construção">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes" />
      </HelmetCustom>

      <Container>
        <Content>
          {empresa?.url && (
            <Logo
              src={logoCabecalho(identidade, empresa)}
              alt={empresa.nome || empresa.razao_social || 'Logo da empresa'}
              title={empresa.nome || empresa.razao_social}
            />
          )}
          <Icon>🚧</Icon>

          <Title>Site em Construção</Title>

          <Subtitle>
            Estamos trabalhando para trazer uma nova experiência para você!
          </Subtitle>

          {empresa && (
            <InfoBox>
              <InfoLabel>Empresa:</InfoLabel>
              <InfoValue>{empresa.nome || empresa.razao_social || 'Não identificada'}</InfoValue>

              {empresa.sac_email && (
                <>
                  <InfoLabel>E-mail SAC:</InfoLabel>
                  <InfoValue>{empresa.sac_email}</InfoValue>
                </>
              )}

              {empresa.sac_telefone && (
                <>
                  <InfoLabel>Telefone SAC:</InfoLabel>
                  <InfoValue>{empresa.sac_telefone}</InfoValue>
                </>
              )}
            </InfoBox>
          )}

          <Subtitle style={{ marginTop: '2rem', fontSize: '1rem' }}>
            Em breve estaremos de volta com novidades!
          </Subtitle>
        </Content>
      </Container>
    </>
  );
}
